// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"920834a7","475":"920834a7","805":"920834a7"}[chunkId] + ".chunk.css";
};